module.exports = __webpack_public_path__ + "img/junfei2.e5e06fcd.png";